import template from "./cost-folder-modal.html";

const CostFolderModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class CostFolderModalController {
    /* @ngInject */
    constructor($rootScope, $filter, CostFolder, Notification) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.CostFolder = CostFolder;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.costFolder =
        this.resolve.costFolder instanceof this.CostFolder
          ? angular.copy(this.resolve.costFolder)
          : new this.CostFolder();
      this.saving = false;
    }

    async save() {
      if (!this.form.$valid) return;

      this.saving = true;
      await this.costFolder.save();
      this.saving = false;
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.saveCostFolder"),
      });
      this.close({ $value: this.costFolder });
      this.$rootScope.$applyAsync();
    }
  },
};

export default CostFolderModalComponent;
